.ViewButton {
  display: flex;
  gap: 4px;
  align-items: center;
  cursor: pointer;

  &-Icon {
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      width: 16px;
      height: 16px;
    }
  }

  &-Label {
    font: var(--font-caption-lg-semibold);
    text-transform: uppercase;
  }
}